module.exports = __webpack_public_path__ + "img/keyvisual-vereinsfoerderung.60917110.webp";